"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntertainmentExperimentGroupResponseSchema = exports.EntertainmentProductDetailForUISchema = exports.EntertainmentProductLinkSchema = exports.EntertainmentProductDetailResponseSchema = exports.EntertainmentMaintenanceResponseSchema = exports.EntertainmentMaintenanceSchema = exports.EntertainmentProductSchema = exports.ProductStatus = void 0;
var zod_1 = require("zod");
var ci_1 = require("../member/ci");
var common_1 = require("./common");
exports.ProductStatus = {
    WAITING_FOR_SALE: 'WAITING_FOR_SALE',
    IN_SALE: 'IN_SALE',
    SOLD_OUT: 'SOLD_OUT',
    END_OF_SALE: 'END_OF_SALE',
};
var Maintenance = zod_1.z.object({
    title: zod_1.z.string(),
    message: zod_1.z.string(),
    startDateTime: zod_1.z.string(),
    endDateTime: zod_1.z.string(),
});
exports.EntertainmentProductSchema = zod_1.z.object({
    productId: zod_1.z.number(),
    productName: zod_1.z.string(),
    productCode: zod_1.z.string(),
    productStatusCode: zod_1.z.nativeEnum(exports.ProductStatus),
    productVersion: zod_1.z.number(),
    isAdultCertificationRequired: zod_1.z.boolean(),
    saleStartDateTime: zod_1.z.string(),
    posterImageUrl: zod_1.z.string(),
    isSkipSale: zod_1.z.boolean(),
});
exports.EntertainmentMaintenanceSchema = zod_1.z.object({
    isValidMaintenance: zod_1.z.boolean(),
    maintenance: Maintenance.nullable(),
});
var AgreementAndCiSchema = zod_1.z.object({
    isCertificationRequired: zod_1.z.boolean().nullable(),
    adultStatus: zod_1.z.nativeEnum(ci_1.AdultStatus).nullable().optional(),
});
exports.EntertainmentMaintenanceResponseSchema = (0, common_1.EntertainmentCommonAPIResponseSchema)(exports.EntertainmentMaintenanceSchema);
exports.EntertainmentProductDetailResponseSchema = (0, common_1.EntertainmentCommonAPIResponseSchema)(exports.EntertainmentProductSchema);
exports.EntertainmentProductLinkSchema = zod_1.z.object({
    app: zod_1.z.string(),
    web: zod_1.z.string(),
});
var EntertainmentProductForUISchema = exports.EntertainmentProductSchema.merge(zod_1.z.object({
    link: exports.EntertainmentProductLinkSchema.nullable(),
}));
exports.EntertainmentProductDetailForUISchema = AgreementAndCiSchema.merge(zod_1.z.object({
    product: EntertainmentProductForUISchema.nullable(),
}));
exports.EntertainmentExperimentGroupResponseSchema = (0, common_1.EntertainmentCommonAPIResponseSchema)(zod_1.z.object({
    experimentGroupCode: zod_1.z.string(),
}));
